import { TitleAndColumns } from './common';

export const transportTitleAndColumns: TitleAndColumns = {
    1: null,
    2: null,
    3: null,
    4: null,
};
